module.exports = __webpack_public_path__ + "static/media/rb.57aea7b2.png";